import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker as AntDatePicker } from 'antd';
import dayjs from 'dayjs';
import { useTheme } from '../../../contexts/ThemeContext';

const DatePicker = ({
  id,
  value,
  onChange,
  placeholder,
  format = 'DD/MM/YYYY',
  showTime,
  className = '',
  style = {},
  ...props
}) => {
  const { theme } = useTheme();

  const datePickerStyle = {
    backgroundColor: theme.backgroundSecondary,
    borderColor: theme.border,
    color: theme.textSecondary,
    transition: 'all 0.3s ease',
    ...style,
  };

  const dropdownStyle = {
    backgroundColor: theme.backgroundSecondary,
    borderColor: theme.border,
  };

  return (
    <AntDatePicker
      id={id}
      value={dayjs.isDayjs(value) ? value : value ? dayjs(value) : null}
      onChange={(date) => onChange?.(id, date)}
      placeholder={placeholder}
      format={format}
      showTime={showTime}
      className={`custom-datepicker ${className}`}
      style={datePickerStyle}
      dropdownStyle={dropdownStyle}
      {...props}
    />
  );
};

DatePicker.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  format: PropTypes.string,
  showTime: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object
};

export default DatePicker; 